export function getFormateDateString(dateString, formatString = "-") {
  const date = new Date(dateString);
  let month = date.getMonth() + 1;
  if (month < 10) {
    month = "0" + month;
  }
  let day = date.getDate();
  if (day < 10) {
    day = "0" + day;
  }
  return date.getFullYear() + formatString + month + formatString + day;
}

export function getFileName(path) {
  const pos1 = path.lastIndexOf("/");
  const pos2 = path.lastIndexOf("\\");
  const pos = Math.max(pos1, pos2);
  if (pos < 0) {
    return path;
  } else {
    return path.substring(pos + 1);
  }
}

export function getQueryString(url, name) {
  const search = url;
  const reg = new RegExp("(^|\\?|&)" + name + "=([^#|&]*)(#|&|$)");
  if (search) {
    const r = search.match(reg);
    if (r != null) {
      return decodeURIComponent(r[2]);
    }
    return null;
  }
}
export function downloadFile(fileUrl, fileName) {
  const a = document.createElement("a");
  const event = new MouseEvent("click");
  console.log("fileUrl, fileName", fileUrl, fileName);
  a.href = fileUrl;
  a.download = fileName;
  a.dispatchEvent(event);
  a.remove();
}

// 下载文件流
export const download = (res, filename) => {
  // 创建blob对象，解析流数据
  const blob = new Blob([res]);
  // 这里就是创建一个a标签，等下用来模拟点击事件
  const a = document.createElement("a");
  // 兼容webkix浏览器，处理webkit浏览器中href自动添加blob前缀，默认在浏览器打开而不是下载
  const URL = window.URL || window.webkitURL;
  // 根据解析后的blob对象创建URL 对象
  const herf = URL.createObjectURL(blob);
  // 下载链接
  a.href = herf;
  // 下载文件名,如果后端没有返回，可以自己写a.download = '文件.pdf'
  a.download = filename;
  document.body.appendChild(a);
  // 点击a标签，进行下载
  a.click();
  // 收尾工作，在内存中移除URL 对象
  document.body.removeChild(a);
  window.URL.revokeObjectURL(herf);
};

export const isEmptyVal = (val) => {
  return val === "" || val === undefined || val === null;
};


export const awaitWrap = (promise) => promise
  .then(data => [null, data])
  .catch(err => [err, null]);

// 字节转MB、GB
export const byteChange = (byte, rate = 1) => {
  let size = "";
  if (byte < rate * 1024) {
    // 小于${rate}KB 则转化成B
    size = byte.toFixed(2) + "B";
  } else if (byte < rate * 1024 * 1024) {
    // 小于${rate}MB 则转换成KB
    size = (byte / 1024).toFixed(2) + "KB";
  } else if (byte < rate * 1024 * 1024 * 1024) {
    // 小于${rate}GB 则转换成MB
    size = (byte / (1024 * 1024)).toFixed(2) + "MB";
  } else if (byte < rate * 1024 * 1024 * 1024 * 1024) {
    // 小于${rate}TB 则转换成GB
    size = (byte / (1024 * 1024 * 1024)).toFixed(2) + "GB";
  } else if (byte < rate * 1024 * 1024 * 1024 * 1024 * 1024) {
    // 小于${rate}PB 则转换成TB
    size = (byte / (1024 * 1024 * 1024 * 1024)).toFixed(2) + "TB";
  } else if (byte < rate * 1024 * 1024 * 1024 * 1024 * 1024 * 1024) {
    // 小于${rate}EB 则转换成PB
    size = (byte / (1024 * 1024 * 1024 * 1024 * 1024)).toFixed(2) + "PB";
  } else if (byte < rate * 1024 * 1024 * 1024 * 1024 * 1024 * 1024 * 1024) {
    // 小于${rate}ZB 则转换成EB
    size =
      (byte / (1024 * 1024 * 1024 * 1024 * 1024 * 1024)).toFixed(2) + "EB";
  } else if (
    byte <
    rate * 1024 * 1024 * 1024 * 1024 * 1024 * 1024 * 1024 * 1024
  ) {
    // 小于0.1YB 则转换成ZB
    size =
      (byte / (1024 * 1024 * 1024 * 1024 * 1024 * 1024 * 1024)).toFixed(2) +
      "ZB";
  } else {
    size = byte;
  }
  return size;
};